"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusRingTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const colors_1 = require("../../../themes/colors/colors");
const focusRingSeparatorWidth = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'focusRing-separator-width',
    fallback: '0px'
});
const focusRingMainWidth = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'focusRing-main-width',
    fallback: '0px'
});
const focusRingMainColor = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-focusRing-main',
    fallback: colors_1.colors.B500
});
const focusRingSeparatorColor = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'color-focusRing-separator',
    fallback: '#FFFFFF'
});
exports.focusRingTokens = {
    focusRingSeparatorWidth,
    focusRingMainWidth,
    focusRingMainColor,
    focusRingSeparatorColor
};
//# sourceMappingURL=FocusRing.js.map